/* eslint-disable no-undef */
import NiceSelect from "nice-select2";

let firstLoad = true;
let markeCanBePulled = false;
const valuation = {

  init() {
    markeCanBePulled = true,
    this.hamburger();
    this.form();
    this.addACTag();
    // this.fillFormHash();
    this.fillValuationFields();
    this.afterFormSubmit();
    this.fillEmail();
    this.selectVehicleType();
    this.checkIfRequiredEmpty();
    this.addHastToBtnLink();
    this.validateInputLength(); // Add new function call

    // this.showCurrentMarkModel();
    // this.showCurrentMarkModelHusbil();
    // this.updateFormModels();
    // this.fetchMarke();
    this.initMarkeFetch();
    this.triggerModelFetch();
    this.formFill();
    this.confidenceFill();
    this.onModelChange();
    // this.sendClientEmail('200 000kr - 100 000kr');
    this.dataSubmissionCRM();
    this.regNrUpdate();
    this.regionSelect();
    this.equipmentPrice();
    this.hiddenFormFields();
    this.dynamicBlockView();
    this.handleResultForm(); // Handle result page forms
    console.log('Valuation form ready');
  },
  regNrUpdate(){
    const regNr = localStorage.getItem('regnr-vehicle');

    if (regNr) {
        const regInput = document.querySelector('#reg');
        const regHusInput = document.querySelector('#reg-hus');

        if (regInput) {
            regInput.value = regNr;
        }
        if (regHusInput) {
            regHusInput.value = regNr;
        }
    }
  },
  hamburger() {
    const switchMenu = document.getElementById('switchMenu');

    if (!switchMenu) {
      return null;
    }
    const headerMenu = document.querySelector('.header');
    const textOpen = switchMenu.querySelector('.screen-reader-text.open');
    const textClose = switchMenu.querySelector('.screen-reader-text.close');

    let switchOn = false;
    switchMenu.addEventListener('click', () => {
      if (!switchOn) {
        switchMenu.classList.add('open');
        headerMenu.classList.add('open');
        textOpen.classList.remove('active');
        textClose.classList.add('active');
        switchOn = true;
      } else {
        switchMenu.classList.remove('open');
        headerMenu.classList.remove('open');
        textOpen.classList.add('active');
        textClose.classList.remove('active');
        switchOn = false;
      }
    });
    return null;
  },
  getRegNrFromUrl() {
    const url = window.location.href;
    const urlObj = new URL(url);
    const regNr = urlObj.searchParams.get('reg-nr');
    return regNr;
  },
  getHashFromUrl() {
    const url = window.location.href;
    const urlObj = new URL(url);
    // const formHash = urlObj.searchParams.get('formHash');

    const formHash = localStorage.getItem('form-hash') || '';

    return formHash;
  },
  initNiceSelect(selectId) {
    let select = document.getElementById(selectId);
    
    if (!select) {
      if (selectId.includes('marke-')) {
        select = document.getElementById('marke');

      } else if (selectId.includes('model-')) {
        select = document.getElementById('modell');
      }
    }
  
    if (select) {
      const selectedOption = select.options[select.selectedIndex];
      let placeholderText;
      
      // Custom placeholder for region select
      if (selectId === 'region' || selectId === 'region-hus') {
        placeholderText = selectedOption && selectedOption.value ? selectedOption.value : 'Region';
      } else {
        placeholderText = selectedOption && selectedOption.value ? selectedOption.value : 'Välj...';
      }
    
      const options = {
        searchable: true,
        placeholder: placeholderText,
        searchtext: 'Sök',
      };
  
      let instance = new NiceSelect(select, options);

      if (selectId === 'marke' || selectId.includes('marke-')) {
        select.style.display = 'none';
      }

      if (selectId === 'arsmodell' || 'arsmodell-hus') {
        select.style.display = 'none';
      }

      // Custom search functionality
      setTimeout(() => {
        const searchInputs = document.querySelectorAll('.nice-select-search-box input');
        
        function normalizeText(text) {
          return text
            .replace(/\s+/g, '') // Ignore spacing
            .replace(/[üÜ]/g, 'u') // Replace letter "Ü"
            .replace(/[öÖ]/g, 'o') // Replace letter "Ö"
            .replace(/[äÄ]/g, 'a') // Replace letter "Ä"
            .replace(/[åÅ]/g, 'a') // Replace letter "Å"
            .toLowerCase();
        }
  
        searchInputs.forEach(input => {
          const list = input.closest('.nice-select').querySelector('.list');
          const listItems = list.querySelectorAll('li');
  
          input.addEventListener('input', function () {
            const searchValue = normalizeText(input.value);
  
            listItems.forEach(item => {
              const text = normalizeText(item.textContent);
              if (text.includes(searchValue)) {
                item.style.display = '';
              } else {
                item.style.display = 'none';
              }
            });
          });
        });
      }, 100);
    } else {
      // console.warn(`No select element found with ID: ${selectId}`);
    }
  },
  setModelSession(data) {
    if (data) {
      localStorage.setItem('vincents-model', JSON.stringify(data));
    }
  },
  getModelSession() {
    const data = localStorage.getItem('vincents-model');
    return JSON.parse(data);
  },
  getModelNameSession() {
    const data = localStorage.getItem('vincents-model-name');
    return data;
  },
  setValuationSession(data) {
    if (data) {
      localStorage.setItem('vincents-mvaluation', JSON.stringify(data));
    }
  },
  getValuationSession() {
    const data = localStorage.getItem('vincents-mvaluation');
    return JSON.parse(data);
  },
  selectVehicleType() {

    const backButtons = document.querySelectorAll('.cf7mls_back');
    if (backButtons) {
      backButtons.forEach((backButton) => {
        backButton.addEventListener('click', () => {
          const fcCheckboxes = document.querySelector('.fc-checkboxes');
          const fcFirstText = document.querySelector('.form-title');
          if (fcCheckboxes && fcFirstText) {
            fcCheckboxes.style.display = 'block';
            fcFirstText.style.display = 'block';
          }
        });
      });
    }

    
    // localStorage.setItem('vincents-vehicle-type', 'husbil');
    const loadingSelectors = document.querySelectorAll('.line-wrapper');

    const radioButtons = document.getElementsByName('car-type');
    
    let selectedValue = 'husvagn'; // Default value
    let isTargetPage = false;

    const mainContent = document.getElementById('main-content');
    const defaultChoice = mainContent ? mainContent.dataset.defaultChoice : null;

    if (defaultChoice === 'husvagn') {
      selectedValue = 'husvagn';
      isTargetPage = true;
    } else if (defaultChoice === 'husbil') {
      selectedValue = 'husbil';
      isTargetPage = true;
    }

    if (isTargetPage) {
      const select = document.querySelector('select#car-type');
      if (select) {
        select.value = selectedValue;
    
        const event = new Event('change', { bubbles: true });
        select.dispatchEvent(event);

        setTimeout(() => {
          const niceSelectWrapper = document.querySelector('.fc-checkboxes .nice-select');
    
          if (niceSelectWrapper) {
            const selectedOptionText = select.options[select.selectedIndex].textContent;
    
            const current = niceSelectWrapper.querySelector('.current');
            if (current) {
              current.textContent = selectedOptionText;
            }
    
            const dropdownItems = niceSelectWrapper.querySelectorAll('.list li');
            dropdownItems.forEach(li => li.classList.remove('selected'));
    
            const selectedDropdownItem = Array.from(dropdownItems).find(
              li => li.dataset.value === selectedValue
            );
            if (selectedDropdownItem) {
              selectedDropdownItem.classList.add('selected');
            }
          }
        }, 100);
      }
    
      radioButtons.forEach((radio) => {
        if (radio.value === selectedValue) {
          radio.checked = true;
          const radioEvent = new Event('change', { bubbles: true });
          radio.dispatchEvent(radioEvent);
        }
      });
    }
    

    localStorage.setItem('vincents-vehicle-type', selectedValue);
    
    const formHusbil = document.querySelector('.form-husbil');
    const formHusvagn = document.querySelector('.form-husvagn');
  
    if (selectedValue === 'husbil') {
      if (formHusbil) formHusbil.style.display = 'block';
      if (formHusvagn) formHusvagn.style.display = 'none';
    } else {
      if (formHusbil) formHusbil.style.display = 'none';
      if (formHusvagn) formHusvagn.style.display = 'block';
    }
    
    if (radioButtons) {
    
      radioButtons.forEach((radio) => {
        radio.addEventListener('change', () => {
          selectedValue = radio.value;
          localStorage.setItem('vincents-vehicle-type', selectedValue);
          localStorage.setItem('crm-vehicle-type', selectedValue);
          // Clear saved marke
          localStorage.removeItem('vincents-vehicle-brand');
          localStorage.removeItem('estimated-price');
          localStorage.removeItem('confidence-value');
          
          this.clearValidationMessages();

          this.fillFormHash();
    
          // Toggle visibility based on selectedValue
          if (selectedValue === 'husbil') {
            formHusbil.style.display = 'block';
            formHusvagn.style.display = 'none';
          } else if (selectedValue === 'husvagn') {
            formHusbil.style.display = 'none';
            formHusvagn.style.display = 'block';
            localStorage.setItem('vincents-vehicle-milage', '');
          }
          loadingSelectors.forEach((element) => {
            element.classList.remove('loading--select');
          });
        });
      });
    }

    //INTEREST
    function setupInterestChecker(selector, storageKey) {
      const element = document.querySelector(selector);
      // console.log('setupInterestChecker');
      // console.log('Current element ' + element);
      if (!element) return;

      // console.log('Current element null ' + element);
      element.addEventListener('change', function() {
        const selectedOption = this.options[this.selectedIndex];
        // console.log('selectet marke ' + selectedOption);
        // localStorage.setItem('vincents-husbil-model', selectedOption);
        // localStorage.setItem('vincents-husvagn-model', selectedOption);

        // console.log(selectedOption.hasAttribute('data-not-interested'));
        if (selectedOption.hasAttribute('data-not-interested')) {
          // console.log('not interested');
          localStorage.setItem(storageKey, 'not-interested');
          // const test = localStorage.getItem(storageKey);
          // console.log('test ' + test);
        } else {
          localStorage.removeItem(storageKey);
        }
      });
    }
    setupInterestChecker('#marke', 'mark-interest');
    
    // setupInterestChecker('#marke-husbil', 'mark-interest');
    // setupInterestChecker('#marke-husvagn', 'mark-interest');

    // }

    const mitialWrapper = document.getElementById('miltal-wrapper');
    // const textHusbil = document.querySelector('.second-text.husbil');
    // const textHusvagn = document.querySelector('.second-text.husvagn');
    const form = document.querySelector('.fc-form');
    const husbilBrand = document.getElementById('husbil-marke-wrapper');
    const husbilModel = document.getElementById('husbil-model-wrapper');
    const husvagnBrand = document.getElementById('husvagn-marke-wrapper');
    const husvagnModel = document.getElementById('husvagn-model-wrapper');
    const regnrInput = document.getElementById('regnr');

    this.initNiceSelect('miltal');
    // this.initNiceSelect('marke-husbil');
    // this.initNiceSelect('marke-husvagn');
    // this.initNiceSelect('model-husbil');
    // this.initNiceSelect('model-husvagn');
    this.initNiceSelect('car-type');
    this.initNiceSelect('arsmodell');
    this.initNiceSelect('arsmodell-hus');
    if (!mitialWrapper) {
      return null;
    }
    // localStorage.setItem('vincents-vehicle-type', 'husbil');
    const initialVehicleType = localStorage.getItem('vincents-vehicle-type');
    // console.log(initialVehicleType);

    const regNrFromUrl = this.getRegNrFromUrl();
    if (regNrFromUrl) {
      regnrInput.value = regNrFromUrl;
    }

    const updateUI = (vehicleType) => {
      //Check if is vehicle type husvagn
      const isHusvagn = vehicleType === 'husvagn';

      //Settings when husbil
      mitialWrapper.classList.toggle('hide', isHusvagn);
      husbilBrand.classList.toggle('hide', isHusvagn);
      husbilBrand.querySelector('select').required = !isHusvagn;
      husbilModel.classList.toggle('hide', isHusvagn);
      husbilModel.querySelector('input').required = !isHusvagn;
      mitialWrapper.querySelector('select').required = !isHusvagn;

      //Settings when husvagn
      husvagnBrand.classList.toggle('hide', !isHusvagn);
      husvagnBrand.querySelector('select').required = isHusvagn;
      husvagnModel.classList.toggle('hide', !isHusvagn);
      husvagnModel.querySelector('input').required = isHusvagn;
      form.classList.toggle('husvagn', isHusvagn);
    };

    if (initialVehicleType) {
      updateUI(initialVehicleType);
      // document.getElementById(initialVehicleType).checked = true;
      radioButtons.value = initialVehicleType;
    }

    // radioButtons.forEach((radioButton) => {
    //   radioButton.addEventListener('click', () => {
    //     if (radioButton.checked) {
    //       localStorage.setItem('vincents-vehicle-type', radioButton.id);
    //       updateUI(radioButton.id);
    //     }
    //   });
    // });

    radioButtons.addEventListener('change', () => {
      // console.log('update');
      const selectedVehicleType = radioButtons.value;
      localStorage.setItem('vincents-vehicle-type', selectedVehicleType);
      updateUI(selectedVehicleType);
      // console.log(selectedVehicleType);

    });

    //Not Interested Marks/Models
    // function setupInterestChecker(selector, storageKey) {
    //   const element = document.querySelector(selector);
    //   // console.log('setupInterestChecker');
    //   console.log('Current element' + element);
    //   if (!element) return;

    //   element.addEventListener('change', function() {
    //     const selectedOption = this.options[this.selectedIndex];
    //     console.log(selectedOption);
    //     localStorage.setItem('vincents-husbil-model', selectedOption);
    //     localStorage.setItem('vincents-husvagn-model', selectedOption);

    //     // console.log(selectedOption.hasAttribute('data-not-interested'));
    //     if (selectedOption.hasAttribute('data-not-interested')) {
    //       localStorage.setItem(storageKey, 'not-interested');
    //       const test = localStorage.getItem(storageKey);
    //       // console.log(test);
    //     } else {
    //       localStorage.removeItem(storageKey);
    //     }
    //   });
    // }
    
    // setupInterestChecker('#marke-husbil', 'mark-interest');
    // setupInterestChecker('#model-husvagn', 'model-interest');
    // setupInterestChecker('#marke-husvagn', 'mark-interest');
    // setupInterestChecker('#model-husbil', 'model-interest');

  },
  form() {
    const form = document.getElementById('valuation_form');
    const milageInput = document.getElementById('miltal');
    const regnrInput = document.getElementById('regnr');
    const notice = document.getElementById('notice');
    const submitButton = document.getElementById('submit');
    // const radioButtons = document.getElementsByName('car-type');
    const radioButtons = document.getElementById('car-type');
    // const body = document.body;
    const loadingBlock = document.getElementById('form-hero');

    if (
      !form ||
      !milageInput ||
      !regnrInput ||
      !notice ||
      !submitButton ||
      !radioButtons.length
    ) {
      return;
    }

    const { ajaxUrl } = valuationForm; // Pre-configure ajax URL

    // Mileage change listener
    milageInput.addEventListener('change', () => {
      localStorage.setItem('vincents-vehicle-milage', milageInput.value);
      // console.log(milageInput.value);
    });

    form.addEventListener('submit', (e) => {
      e.preventDefault();

      // Validate registration number length before submission
      const regInput = document.querySelector('#reg, #reg-hus');
      if (regInput && regInput.value.length !== 6) {
        this.showInputLengthError(regInput, 'Vänligen skriv ett giltigt registreringsnummer.');
        return;
      }

      // Check if vincents-vehicle-milage is set in local storage
      let milage = localStorage.getItem('vincents-vehicle-milage');
      let vehicleType = localStorage.getItem('vincents-vehicle-type');

      // radioButtons.forEach((radioButton) => {
        // Clear local storage items not related to this operation
        [
          'vincents-valuation',
          'vincents-model',
          'vincents-model-name',
          'vincents-mvaluation',
        ].forEach((item) => {
          localStorage.removeItem(item);
        });

        // if (radioButton.checked) {
          // If milage not set, determine its value based on the selected radio button
          const selectedVehicleType = radioButtons.value;

          if (!milage) {
            milage = '';
            localStorage.setItem('vincents-vehicle-milage', milage);
          }
          // console.log('milage' + milage);

          // const vehicleType = localStorage.getItem('vincents-vehicle-type');

          if (selectedVehicleType === 'husbil') {
            const husbilSelectValue = document.querySelector('#marke-husbil').value;
            localStorage.setItem('vincents-vehicle-brand-id', husbilSelectValue);

            const husbilSelectLabel = document.querySelector('#marke-husbil option:checked').textContent;
            localStorage.setItem('vincents-vehicle-brand', husbilSelectLabel);

            // const husbilModelValue = document.querySelector('#model-husbil').value;
            const husbilModelValue = document.querySelector('#model-husbil').getAttribute('data-value');
            // console.log('model ID: ' + husbilModelValue);
            localStorage.setItem('vincents-husbil-model-id', husbilModelValue);

            // const husbilModelLabel = document.querySelector('#model-husbil option:checked').textContent;
            const husbilModelLabel = document.querySelector('#model-husbil').value;
            // console.log('model Name: ' + husbilModelLabel);
            localStorage.setItem('vincents-husbil-model', husbilModelLabel);

            const regValue = document.querySelector('#reg').value;
            localStorage.setItem('regnr-vehicle', regValue);
          } else {
            const husvagnSelectValue = document.querySelector('#marke-husvagn').value;
            localStorage.setItem('vincents-vehicle-brand-id', husvagnSelectValue);

            const husvagnSelectLabel = document.querySelector('#marke-husvagn option:checked').textContent;
            localStorage.setItem('vincents-vehicle-brand', husvagnSelectLabel);

            // const husvagnModelValue = document.querySelector('#model-husvagn').value;
            const husvagnModelValue = document.querySelector('#model-husvagn').getAttribute('data-value');
            // console.log('model ID: ' + husvagnModelValue);
            localStorage.setItem('vincents-husvagn-model-id', husvagnModelValue);

            // const husvagnModelLabel = document.querySelector('#model-husvagn option:checked').textContent;
            const husvagnModelLabel = document.querySelector('#model-husvagn').value;
            // console.log('model Name: ' + husvagnModelLabel);
            localStorage.setItem('vincents-husvagn-model', husvagnModelLabel);

            const regValue = document.querySelector('#reg-hus').value;
            localStorage.setItem('regnr-vehicle', regValue);
          }

        // }
      // });

      const formData = new FormData();
      formData.append('action', 'valuation_form_ajax');
      formData.append('regnr', regnrInput.value);

      notice.innerHTML = '';
      submitButton.disabled = true;
      loadingBlock.classList.add('loading');
      
      // console.log(ajaxUrl);
      fetch(ajaxUrl, {
        method: 'POST',
        body: formData,
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then((res) => {
          // console.log(res);
          if (res && res.data && res.data.length > 0) {
            // console.log(res.data[0]); // first element of the data array
            this.setModelSession(res.data[0]);
            this.redirects(true);
          } else {
            // console.log('No data or incorrect data format');
            this.redirects(false);
          }
        })
        .catch((error) => {
          console.error('Fetch error:', error);
          notice.innerHTML = 'Error processing your request.';
        })
        .finally(() => {
          submitButton.disabled = false;
        });
    });
  },
  updateFormModels(){

    const vehicleType = localStorage.getItem('vincents-vehicle-type');
    // console.log(vehicleType);

    if (vehicleType === 'husbil') {
      // console.log(vehicleType);

      const markSelectHus = document.querySelector('select[name="marke-hus"]');
      if (markSelectHus) {
        markSelectHus.addEventListener('change', () => {
          const selectedMarkHus = markSelectHus.value;
          this.updateFormFields(selectedMarkHus);
        });
      }

      if ( markSelectHus && markSelectHus.value ) {
        this.updateFormFields( markSelectHus.value );
      }
    } else {
      // console.log(vehicleType);

      const markSelect = document.querySelector('select[name="marke"]');

      if (markSelect) {
        markSelect.addEventListener('change', () => {
          const selectedMark = markSelect.value;
          this.updateFormFields(selectedMark);
        });
      }

      if ( markSelect && markSelect.value ) {
        this.updateFormFields( markSelect.value );
      }
    }
  },

  formFill() {
    const nextForm = document.querySelector('.valuation_form_next form');
    const vehicleType = localStorage.getItem('vincents-vehicle-type');
    // console.log('vehicleType: ' + vehicleType);

    if (!nextForm) {
      return;
    }

    const fillFormField = (selector, value = '') => {
      const field = nextForm.querySelector(selector);
      if (field) field.value = value;
    };

    if (vehicleType === 'husbil') {
      const vehicleMilage =
        localStorage.getItem('vincents-vehicle-milage') || '';
      const husbilModel =
        localStorage.getItem('vincents-husbil-model') || '';
        // console.log('husbilModel: ' + husbilModel);

      fillFormField('select[name="mitial"]', vehicleMilage);
      // console.log('vehicleMilage: ' + vehicleMilage);
      // fillFormField('select[name="modell-hus"]', husbilModel);
      document.getElementById('model-label').textContent = husbilModel;
      document.getElementById('modell').value = husbilModel;
      fillFormField('input[name="modell-hus"]', husbilModel);
      const selectetBrand = localStorage.gerItem('vincents-vehicle-brand');
      valuation.fillFormField('#marke', selectetBrand);
      valuation.fillFormField('#markeValue', selectetBrand);
    } else {
      const husvagnModel =
      localStorage.getItem('vincents-husvagn-model') || '';
      fillFormField('input[name="modell"]', husvagnModel);
      document.getElementById('modell').value = husvagnModel;
      document.getElementById('model-label').textContent = husvagnModel;
      const selectetBrand = localStorage.gerItem('vincents-vehicle-brand');
      valuation.fillFormField('#marke-hus', selectetBrand);
      valuation.fillFormField('#markeValue-hus', selectetBrand);
    }

    const regVall =
    localStorage.getItem('regnr-vehicle') || '';
    fillFormField('input[name="reg"]', regVall);

    const data = this.getModelSession();
    if (data) {
      const { Registreringsnummer, Fordonsuppgifter, TekniskData } = data;
      const { Fordonsbenamning, Handelsbeteckning, Farg, Armodell } =
        Fordonsuppgifter || {};
      const { Totalvikt, Tjanstevikt, Vaxellada } = TekniskData || {};

      document.querySelectorAll('#modelName').forEach((name) => {
        name.innerHTML = `${Fordonsbenamning} ${Handelsbeteckning}`;
      });

      fillFormField('input[name="reg"]', Registreringsnummer);
      const vehicleBrand = localStorage.getItem('vincents-vehicle-brand') || '';
      // console.log(vehicleBrand);
      if (vehicleBrand) {
        fillFormField('select[name="marke"]', vehicleBrand);
        document.getElementById('mark-label').textContent = vehicleBrand;
      } else {
        fillFormField('select[name="marke"]', Fordonsbenamning);
      }
      fillFormField('select[name="modell"]', Handelsbeteckning);
      fillFormField('select[name="arsmodell"]', Armodell);
      fillFormField('input[name="farg"]', Farg);
      fillFormField('input[name="totalvikt"]', Totalvikt);
      fillFormField('input[name="tjanstevikt"]', Tjanstevikt);

      if (vehicleType === 'husbil') {
        fillFormField('input[name="vaxellada"]', Vaxellada);
      }
    } else {
      const vehicleBrand = localStorage.getItem('vincents-vehicle-brand') || '';
      if (vehicleBrand) {
        document.getElementById('mark-label').textContent = vehicleBrand;
        if (vehicleType === 'husbil') {
          fillFormField('select[name="marke-hus"]', vehicleBrand);
        } else {
          fillFormField('select[name="marke"]', vehicleBrand);
        }
      }
    }


    this.initNiceSelect('mitial');
    // this.initNiceSelect('marke');
    this.clearArsmodel();
    this.initNiceSelect('arsmodell');
    this.initNiceSelect('arsmodell-hus');
    // this.initNiceSelect('modell');

    this.afterFormSubmit();
  },
  clearArsmodel(){
    // console.log('clear');
    const selectArsmodel = document.getElementById('arsmodell');
    if(selectArsmodel){
      const optionArsmodel = document.createElement('option');
      optionArsmodel.textContent = 'Välj...';
      optionArsmodel.value = '';
      selectArsmodel.insertBefore(optionArsmodel, selectArsmodel.firstChild);
      selectArsmodel.selectedIndex = 0;
    }
  },
  redirects(apiTrue) {
    const data = localStorage.getItem('vincents-vehicle-type');

    if (data === 'husvagn') {
      if (apiTrue) {
        window.location.href = `vardering-ditt-fordon-husvagn/`;
      } else {
        window.location.href = `vardering-ditt-fordon-saknas-husvagn/`;
      }
    } else {
      if (apiTrue) {
        window.location.href = `vardering-ditt-fordon/`;
      } else {
        window.location.href = `vardering-ditt-fordon-saknas/`;
      }
    }
  },
  // calculateValuation(avg, min) {
  //   avg = parseFloat(avg);
  //   min = parseFloat(min);
  //   // console.log(avg);
  //   // console.log(min);
  //   // Check if the conversion resulted in NaN
  //   if (isNaN(avg) || isNaN(min)) {
  //       throw new TypeError('Both avg and min must be valid numbers');
  //   }

  //   const avgOfAverages = (avg + min) / 2;
  //   // Define the gap
  //   const gap = 20000;

  //   // Calculate the valuation range
  //   const minValuation = Math.round(avgOfAverages - gap);
  //   const maxValuation = Math.round(avgOfAverages + gap);
  //   return {
  //       minValuation: minValuation,
  //       maxValuation: maxValuation
  //   };
  // },
  async checkApiValuation(marke, model, arsmodell, miltal) {
    localStorage.removeItem('vincents-mvaluation');
    const formData = new FormData();
    formData.append('action', 'api_valuation_form_ajax');
    formData.append('marke', marke);
    formData.append('model', model);
    formData.append('arsmodell', arsmodell);

    if (miltal) {
      formData.append('miltal', miltal);
    }

    const modelStatus = localStorage.getItem('model-status');
    formData.append('model_status', modelStatus);

    try {
      const response = await fetch(SiteVars.ajaxUrl, {
        method: 'POST',
        body: formData,
      });
      
      const res = await response.json();
      
      // Check if server returned limit reached error
      if (res.success === false && res.data && res.data.limit_reached) {
        console.log('Server limit reached:', res.data.message);
        this.showLimitPopup();
        return null;
      }
      
      // Validate response data
      this.setValuationSession(res);

      if (!res || !res.data) {
        // console.error('Invalid API response:', res);
        return res;
      }

      let newMaxVal;
      let minCalculated;
      let roundedNewMinVal;

      // function roundValues(value) {
      //   const remainder = value % 10000;
      //   if (remainder < 5000) {
      //     return Math.floor(value / 10000) * 10000 - 100;
      //   } else {
      //     return Math.ceil(value / 10000) * 10000 - 100;
      //   }
      // }

      // // Validate avg and min values before calculations
      // const avgVal = res.data.avg ? parseFloat(res.data.avg) : null;
      // const minVal = res.data.min ? parseFloat(res.data.min) : null;

      // if (avgVal === null || minVal === null || isNaN(avgVal) || isNaN(minVal)) {
      //   // console.error('Invalid valuation data:', { avg: res.data.avg, min: res.data.min });
      //   return res;
      // }

      // const newAvgVal = Math.ceil((avgVal + minVal) / 2);
      // const newMinVal = Math.ceil(newAvgVal - 20000);
      // newMaxVal = Math.ceil(newAvgVal + 10000);
      // minCalculated = Math.ceil(newMinVal - 30000);
      // roundedNewMinVal = roundValues(newMinVal);

      // const valuationMax = newMaxVal ? ` - ${this.priceFormat(newMaxVal)} kr` : '';
      // const valuationLow = minCalculated ? `${this.priceFormat(minCalculated)} kr` : '';
      // const valuationSpe = roundedNewMinVal ? `${this.priceFormat(roundedNewMinVal)} kr` : '';

      const valuationMax = res.data.valuation_high ? ` - ${this.priceFormat(res.data.valuation_high)} kr` : '';
      const valuationLow = res.data.valuation_low ? `${this.priceFormat(res.data.valuation_low)} kr` : '';
      const valuationSpe = res.data.specific_price ? `${this.priceFormat(res.data.specific_price)} kr` : '';

      const valuation = valuationLow + valuationMax;
      localStorage.setItem('valuation-price', valuation);
      localStorage.setItem('specific-price', valuationSpe);
      const high = document.getElementById('highest-price');
      if (high) {
        high.classList.add('loading--data');
        const low = document.getElementById('lowest-price');
        if(low){
          low.classList.add('loading--data');
        }

        try {
          // const valuationAvg = this.calculateValuation(avgVal, minVal);
          // const valuationMax = valuationAvg.maxValuation ? ` - ${this.priceFormat(valuationAvg.maxValuation)} kr` : '';
          // const valuationLow = valuationAvg.minValuation ? `${this.priceFormat(valuationAvg.minValuation)} kr` : '';
          const valuationMax = res.data.max_valuation? ` - ${this.priceFormat(res.data.max_valuation)} kr` : '';
          const valuationLow = res.data.min_valuation ? `${this.priceFormat(res.data.min_valuation)} kr` : '';

          const valuation = valuationMax + valuationLow;
          localStorage.setItem('valuation-price', valuation);

          await this.saveValuation(valuation);
          await this.addACVaulation(valuation);
          // sendClientEmail will be called only after result form submission
          
          high.classList.remove('loading--data');
          if(low){
            low.classList.remove('loading--data');
          }
          high.innerHTML = res.data.avg ? `${res.data.avg} kr` : '-';
          low.innerHTML = res.data.min ? `${res.data.min} kr` : '-';
        } catch (error) {
          console.error('Error calculating valuation:', error);
          high.classList.remove('loading--data');
          if(low){
            low.classList.remove('loading--data');
          }
          high.innerHTML = '-';
          low.innerHTML = '-';
        }
      }

      const confidenceVal = res.data.confidence;
      if (confidenceVal) {
        localStorage.setItem('confidence-value', confidenceVal);
      }

      return res;
    } catch (error) {
      console.error('Error fetching valuation:', error);
      return null;
    }
  },
  confidenceFill() {
    const confidenceVal = localStorage.getItem('confidence-value') || '';
    // console.log('confidenceVal = ' + confidenceVal);
    let lowVal = document.querySelector('.confidence-low');
    let midVal = document.querySelector('.confidence-medium');
    let highVal = document.querySelector('.confidence-high');

    if (confidenceVal) { 
      if (confidenceVal === 'medium') {
        if (midVal) { 
          midVal.classList.add('show');
        }
      } else if (confidenceVal === 'low') {
        if (lowVal) { 
          lowVal.classList.add('show');
        }
      } else if (confidenceVal === 'high') {
        if (highVal) { 
          highVal.classList.add('show');
        }
      } else {
        if (highVal) { 
          highVal.classList.add('show');
        }
      }
    }
  },
  priceFormat(price) {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  },
  fillValuationFields() {
    const high = document.getElementById('highest-price');
    if (!high) {
      return;
    }
    const low = document.getElementById('lowest-price');

    let specific = document.getElementById('specific-price');
    let newMaxVal;
    let minCalculated;
    let roundedNewMinVal;

    const data = this.getValuationSession();
    if (null == data || data == undefined) {
      // Don't automatically call checkApiValuation here as it should be called from form submission
      // This prevents automatic API calls that could count against the daily limit
      return;
    } else {

      if (data.data.avg && data.data.min) {
        // Round price values
        // function roundValues(value) {
        //   const remainder = value % 10000;
        //   if (remainder < 5000) {
        //       return Math.floor(value / 10000) * 10000 - 100;
        //   } else {
        //       return Math.ceil(value / 10000) * 10000 - 100;
        //   }
        // }

        // const avgVal = parseFloat(data.data.avg);
        // const minVal = parseFloat(data.data.min);

        // const newAvgVal = Math.ceil((avgVal  + minVal) / 2);
        // const newMinVal = Math.ceil(newAvgVal - 20000);
        // newMaxVal = Math.ceil(newAvgVal + 10000);
        // minCalculated = Math.ceil(newMinVal - 30000);
        // roundedNewMinVal = roundValues(newMinVal);

        newMaxVal = data.data.valuation_high;
        minCalculated = data.data.valuation_low;
        roundedNewMinVal = data.data.specific_price;

        specific.innerHTML = `<span>${roundedNewMinVal} kr</span>`;
        high.innerHTML = `<span>${newMaxVal} kr</span>`;
        low.innerHTML = `<span>${minCalculated} kr</span>`;
        

      } else {
        const avgValuation = 'No average provided';
        const minValuation = 'No minimum provided';
        specific.innerHTML = `<label>Värdering</label><p>Minimum Valuation: ${minValuation}</p><p>Average Valuation: ${avgValuation}</p>`;
      }

      const priceContainers = document.querySelectorAll('.price__block--first, .price__block--second');

      priceContainers.forEach(container => {
          container.classList.add('loading--data');
      });

      // high.classList.add('loading--data');
      // low.classList.add('loading--data');
      // specific.classList.add('loading--data');

      // const valuationAvg = this.calculateValuation(data.data.avg,data.data.min);

      // const valuationMax = valuationAvg.maxValuation ? ` - ${this.priceFormat(valuationAvg.maxValuation)} kr` : '';
      // const valuationLow = valuationAvg.minValuation ? `${this.priceFormat(valuationAvg.minValuation)} kr` : '';

      const valuationMax = newMaxVal ? ` - ${this.priceFormat(newMaxVal)} kr` : '';
      const valuationLow = minCalculated ? `${this.priceFormat(minCalculated)} kr` : '';
      const valuationSpe = roundedNewMinVal ? `${this.priceFormat(roundedNewMinVal)} kr` : '';

      const valuation = valuationLow + valuationMax;
      localStorage.setItem('valuation-price', valuation);
      localStorage.setItem('specific-price', valuationSpe);
      
      const valuationPrice = localStorage.getItem('valuation-price') || '';
      const specificPrice = localStorage.getItem('specific-price') || '';
      console.log('valuationPrice: ' + valuationPrice);
      console.log('specificPrice: ' + specificPrice);

      // sendClientEmail will be called only after result form submission
      this.saveValuation(valuation);
      this.addACVaulation(valuation);

      // Format
      function formatNumberWithSpace(number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      }

      // setTimeout(() =>{
        priceContainers.forEach(container => {
          container.classList.remove('loading--data');
        });
        // high.classList.remove('loading--data');
        // low.classList.remove('loading--data');
        // specific.classList.remove('loading--data');
      //   high.innerHTML = valuationAvg.maxValuation
      //   ? `${this.priceFormat(valuationAvg.maxValuation)} kr`
      //   : '-';
      // low.innerHTML = valuationAvg.minValuation
      //   ? `${this.priceFormat(valuationAvg.minValuation)} kr`
      //   : '-';

      // specific.innerHTML = `<span>${formatNumberWithSpace(roundedNewMinVal)} kr</span>`;
      // high.innerHTML = `<span>${formatNumberWithSpace(newMaxVal)} kr</span>`;
      // low.innerHTML = `<span>${formatNumberWithSpace(minCalculated)} kr</span>`;
      // this.updateValuationFields(roundedNewMinVal, newMaxVal, minCalculated);
      // },2000);
    }

    const dataModel = this.getModelNameSession();
    if (dataModel == null || dataModel == undefined) {
      return;
    }

    const model = document.getElementById('modelName');
    if (model) {
      model.innerHTML = dataModel;
    }
  },
  updateValuationFields(roundedNewMinVal, newMaxVal, minCalculated) {
    function formatNumberWithSpace(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }
    if (document.getElementById('specific-price')) {
      document.getElementById('specific-price').innerHTML = `<span>${formatNumberWithSpace(roundedNewMinVal)} kr</span>`;
    }
    if (document.getElementById('highest-price')) {
      document.getElementById('highest-price').innerHTML = `<span>${formatNumberWithSpace(newMaxVal)} kr</span>`;
    }
    if (document.getElementById('lowest-price')) {
      document.getElementById('lowest-price').innerHTML = `<span>${formatNumberWithSpace(minCalculated)} kr</span>`;
    }
  },
  fillEmail() {
    const emailPlace = document.querySelector('.emailPlace');
    if (!emailPlace) {
      return;
    }
    const email = localStorage.getItem('vincents-user-email');

    if (email) {
        emailPlace.innerHTML = email;
    }
  },
  fillFormHash(){
    const vehicleType = localStorage.getItem('vincents-vehicle-type') || 'husvagn';
    const formHash = document.getElementById(vehicleType === 'husbil' ? 'formHash' : 'formHash-hus');
    if (!formHash) {
      return;
    }
    formHash.value = this.generateDateHash();
    // console.log('formHash: ' + formHash.value);
    localStorage.setItem('form-hash', formHash.value);
  },
  generateDateHash() {
    // Get the current date and time
      const now = new Date();

      // Convert date to a string format that includes milliseconds for higher uniqueness
      const dateString = now.toISOString();

      // Hash function to generate a unique string
      function hashString(str) {
          let hash = 0;
          for (let i = 0; i < str.length; i++) {
              const char = str.charCodeAt(i);
              hash = (hash << 5) - hash + char;
              hash |= 0; // Convert to 32bit integer
          }
          return hash;
      }

      // Generate the hash from the date string
      const hash = hashString(dateString);

      // console.log('hash: ' + hash);
      // Convert the hash to a base-36 string and slice the first 10 characters
      return Math.abs(hash).toString(36).slice(0, 10);
  },
  afterFormSubmit() {
    // const wpcf7Elm = document.querySelector('.wpcf7-form');
    const wpcf7Forms = document.querySelectorAll('.wpcf7-form');

    if (wpcf7Forms.length > 0) {
      wpcf7Forms.forEach((wpcf7Elm) => {
      const nextButton = wpcf7Elm.querySelector('.cf7mls_next');

      //Age value check
      const vehicleType = localStorage.getItem('vincents-vehicle-type');
      // const arsmodellSelect = document.querySelector('#arsmodell');
      const arsmodellSelect = document.querySelector(vehicleType === 'husbil' ? '#arsmodell' : '#arsmodell-hus');
      if (arsmodellSelect) {
        const arsmodellVal = arsmodellSelect.value;
        localStorage.setItem('arsmodell-vehicle', arsmodellVal);

        arsmodellSelect.addEventListener('change', function() {
          const arsmodellNewValue = this.value;
          localStorage.setItem('arsmodell-vehicle', arsmodellNewValue);
        });
      }

      if(nextButton) {
      nextButton.addEventListener('click', (event) => {
        // Prevent default form navigation behavior
        event.preventDefault();
        event.stopPropagation();

        // Find the current fieldset for validation
        const currentFieldset = wpcf7Elm.querySelector('.fieldset-cf7mls:not(.cf7mls_back_fs)');
        if (!currentFieldset) {
          console.error('No current fieldset found for validation');
          return;
        }

        // Validate form before proceeding
        if (!this.validateForm(currentFieldset)) {
          console.log('Form validation failed');
          return;
        }

        const vehicleType = localStorage.getItem('vincents-vehicle-type');
        const vehicleBrand = localStorage.getItem('vincents-vehicle-brand') || '';
        let markeValue, modellValue;
        if (vehicleBrand) {
          markeValue = localStorage.getItem('vincents-vehicle-brand') || '';
          // modellValue = document.getElementById('modellValue').value;
          // modellValue = document.getElementById(vehicleType === 'husbil' ? 'modellValue' : 'modellValue-hus');
          modellValue = localStorage.getItem('vincents-'+vehicleType+'-model') || '';
        }

        // console.log('Type: ' + initialVehicleType);
        const arsmodellName = vehicleType === 'husbil' ? 'arsmodell' : 'arsmodell-hus';

        const arsmodellValue = wpcf7Elm.querySelector(
          `select[name="${arsmodellName}"]`
        ).value;
        const milage = wpcf7Elm.querySelector('select[name="mitial"]');

        if (markeValue && modellValue) {
          localStorage.setItem(
            'vincents-model-name',
            markeValue + ' ' + modellValue
          );
        }

        if (milage) {
          let milageValue = '';
          switch (milage.value) {
            case '0 - 5 000 mil':
              milageValue = '0-5';
              break;
            case '5 000 - 10 000 mil':
              milageValue = '5-10';
              break;
            case '10 000+ mil':
              milageValue = '10-99';
              break;
            default:
              milageValue = '0-5';
          }

          // console.log(milageValue);

          // Add loading class to body
          document.body.classList.add('loading');

          // Wait for API valuation to complete before redirecting
          this.checkApiValuation(
            markeValue,
            modellValue,
            arsmodellValue,
            milageValue
          ).then((res) => {
            this.handleRedirects();
          }).catch((error) => {
            // Remove loading class on error
            document.body.classList.remove('loading');
            console.error('Error in API valuation:', error);
          });
        } else {
          // Add loading class to body
          document.body.classList.add('loading');

          // Wait for API valuation to complete before redirecting
          this.checkApiValuation(markeValue, modellValue, arsmodellValue).then((res) => {
            this.handleRedirects();
          }).catch((error) => {
            // Remove loading class on error
            document.body.classList.remove('loading');
            console.error('Error in API valuation:', error);
          });
          // console.log('Next button (Valuation start)');
        }
      });
    }

    //TEST CUSTOM EMAIL (BEFORE SUBMIT)
    wpcf7Elm.addEventListener('submit', function (event) {
      console.log("Sending...");
      const arsmodellCheck = localStorage.getItem('arsmodell-vehicle') || '';
      const currentYear = new Date().getFullYear();
      const interesMark = localStorage.getItem('mark-interest');
      const interesModel = localStorage.getItem('model-interest');
      const canContacted = localStorage.getItem('can_be_contacted') || '';
      const shouldRedirect = interesMark || interesModel || (currentYear - arsmodellCheck >= 12);
      // const allowedRegions = [
      //   'Skåne', 'Blekinge', 'Halland', 'Jönköpings län', 'Kronoberg', 'Kalmar län',
      //   'Gotland', 'Götalandsregionen', 'Östergötland', 'Örebro län',
      //   'Södermanland', 'Stockholm'
      // ];
      const selectedRegion = localStorage.getItem('tel-region') || '';
      let newEmail = "vardering@rightprice.ai";

      if (shouldRedirect) {
        newEmail = "vardering@rightprice.ai";

      // } else if (canContacted == "1" && allowedRegions.includes(selectedRegion)) {
      //   newEmail = "vardering@rightprice.ai, sofia@rightprice.ai";
      // }
      } else if (canContacted == "1") {
      newEmail = "vardering@rightprice.ai, sofia@rightprice.ai";
      }

      localStorage.setItem('admin-email', newEmail);

      const emailFields = ['#lead-email-hus', '#lead-email'];
      emailFields.forEach(selector => {
          const emailField = wpcf7Elm.querySelector(selector);
          if (emailField) {
              emailField.value = newEmail;
          }
      });
    });

      const body = document.querySelector('body');

      wpcf7Elm.addEventListener(
        'wpcf7mailsent',
        function (event) {
          body.classList.add('loading');
          const data = localStorage.getItem('vincents-mvaluation');
          const email = localStorage.getItem('vincents-user-email') || '';
          // if (email) {
          //   localStorage.setItem('vincents-user-email', email);
          // }
          // console.log(email);
          const parsedData = JSON.parse(data);
          // console.log(parsedData);
          let hash = '';
          let hashSend = '';

          var inputs = event.detail.inputs;

          for ( var i = 0; i < inputs.length; i++ ) {
            if ( 'formhash' == inputs[i].name ) {
              hash = `?formHash=${inputs[i].value}`;
              hashSend = `?action=vsend&formHash=${inputs[i].value}`;
              break;
            }
          }
          //Delete saved data
          setTimeout(function() {
            localStorage.removeItem('mark-interest');
            localStorage.removeItem('model-interest');
            localStorage.removeItem('vincents-vehicle-brand');
            localStorage.removeItem('vincents-user-email');
            localStorage.removeItem('admin-email');
            let storedEmail = localStorage.getItem('admin-email') || '';
            console.log('storedEmail: ' + storedEmail);
          }, 5000);
        },
        false
      );
    });
    }
  },
  handleRedirects() {
    const data = localStorage.getItem('vincents-mvaluation');
    // console.log('data: ' + data);
    if (data) {
      const parsedData = JSON.parse(data);
      const arsmodellCheck = localStorage.getItem('arsmodell-vehicle') || '';
      const currentYear = new Date().getFullYear();
      const interesMark = localStorage.getItem('mark-interest');
      const interesModel = localStorage.getItem('model-interest');
    //   const canContacted = localStorage.getItem('can_be_contacted') || '';
      const shouldRedirect = interesMark || interesModel || (currentYear - arsmodellCheck >= 13);
      // console.log('currentYear : ' + currentYear );
      // console.log('arsmodellCheck : ' + arsmodellCheck );
      // console.log('min : ' + (currentYear - arsmodellCheck));
      // console.log('shouldRedirect : ' + shouldRedirect);

      // Generate hash for redirects
      const formHash = this.generateDateHash();
      const hash = `?formHash=${formHash}`;
      localStorage.setItem('form-hash', formHash);

      //Contact Regions List
      const allowedRegions = [
        'Skåne', 'Blekinge', 'Halland', 'Jönköpings län', 'Kronoberg', 'Kalmar län',
        'Gotland', 'Götalandsregionen', 'Östergötland', 'Örebro län',
        'Södermanland', 'Stockholm'
      ];
      const selectedRegion = localStorage.getItem('tel-region') || '';

        if (parsedData && parsedData.data) {
          if (shouldRedirect) {
            window.location.href = `/vardering-inga-resultat-klar/${hash}`;
            // console.log('redirect to not interested page');
          } else {
            window.location.href = `/vardering-resultat-klar/${hash}`;
            // console.log('redirect to results page');
          }
        } else {
          if (shouldRedirect) {
            window.location.href = `/vardering-inga-resultat-klar/${hash}`;
            // console.log('redirect to not interested page (no data)');
          } else {
            window.location.href = `/vardering-inga-resultat/${hash}`;
            // console.log('redirect to no data page');
          }
        }
        
        // Remove loading class after processing
        document.body.classList.remove('loading');
    }
  },
  addHastToBtnLink(){
    const btn = document.getElementById('requiredContact');
    const hash = this.getHashFromUrl();
    if(!btn || !hash){
      return;
    }

    const url = new URL(btn.href);
    url.searchParams.set('action', 'vsend');
    url.searchParams.set('formHash', hash);
    btn.href = url.toString();
  },
  checkIfRequiredEmpty() {
    const body = document.querySelector('body');
    const forms = document.querySelectorAll('.wpcf7-form'); // Select all forms

    forms.forEach((form) => { // Loop through each form
      const allFieldset = form.querySelectorAll('.fieldset-cf7mls');

      allFieldset.forEach((fieldset) => {
        const firstForm = fieldset.querySelector('.first-form');
        const secondForm = fieldset.querySelector('.second-form');
        // const submitButton = fieldset.querySelector('.cf7mls_next, .wpcf7-submit');
        const submitButton = fieldset.querySelector('.cf7mls_next');
        const nextButton = fieldset.querySelector('.cf7mls_next');

        // Handle form submission
        form.addEventListener('submit', (event) => {
          if (!this.validateForm(fieldset)) {
            event.preventDefault();
            return false;
          }
        });

        // Handle next button click
        if (nextButton) {
          nextButton.addEventListener('click', (event) => {
            if (!this.validateForm(fieldset)) {
              event.preventDefault();
              event.stopPropagation();
              return false;
            }
          });
        }

        // Handle submit button click
        if (submitButton) {
          submitButton.addEventListener('click', (event) => {
            if (!this.validateForm(fieldset)) {
              event.preventDefault();
              event.stopPropagation();
              return false;
            }
          });
        }
      });
    });
  },
  validateForm(fieldset) {
    const form = fieldset.closest('.wpcf7-form');

    const initialVehicleType = localStorage.getItem('vincents-vehicle-type');

    const isHusbilForm = initialVehicleType === 'husbil';
    const isHusvagnForm = initialVehicleType === 'husvagn';

    const allField = fieldset.querySelectorAll('.line-wrapper, .wrapper-textarea, .second-form');
    let allValid = true;

    this.clearValidationMessages();

    // Define required fields based on vehicle type
    const requiredFields = isHusbilForm ? [
      { id: 'marke', wrapper: 'line-wrapper' },
      { id: 'modell', wrapper: 'line-wrapper' },
      { id: 'reg', wrapper: 'line-wrapper' },
      { id: 'arsmodell', wrapper: 'line-wrapper' }
    ] : [
      { id: 'marke', wrapper: 'line-wrapper' },
      { id: 'modell-hus', wrapper: 'line-wrapper' },
      { id: 'reg-hus', wrapper: 'line-wrapper' },
      { id: 'arsmodell-hus', wrapper: 'line-wrapper' }
    ];

    // Validate each required field for this specific form
    requiredFields.forEach(field => {
      const input = form.querySelector(`#${field.id}`);
      if (!input) {
        allValid = false;
        this.validateFieldById(field.id, field.wrapper, form);
      } else if (!input.value) {
        allValid = false;
        this.validateFieldById(field.id, field.wrapper, form);
      } else {
        // Additional validation for registration number fields
        if (field.id === 'reg' || field.id === 'reg-hus') {
          if (input.value.length !== 6) {
            allValid = false;
            this.showInputLengthError(input, 'Vänligen skriv ett giltigt registreringsnummer.');
          }
        }
      }
    });

    // Additional validation for all fields in the current fieldset
    allField.forEach((field) => {
      const input = field.querySelector('input, select, textarea');
      if (input && input.classList.contains('wpcf7-validates-as-required')) {
        if (!input.value) {
          allValid = false;
          if (field.classList.contains('first-form') || field.classList.contains('second-form')) {
            field.classList.add('required-mark');
          } else {
            input.classList.add('required-mark');
          }
        } else {
          if (field.classList.contains('first-form') || field.classList.contains('second-form')) {
            field.classList.remove('required-mark');
          } else {
            input.classList.remove('required-mark');
          }
        }
      }
    });

    if (!allValid) {
      document.body.classList.remove('loading');
      return false;
    }

    return true;
  },
  validateFieldById(fieldId, wrapperClass, form) {
    const field = form.querySelector(`#${fieldId}`);
    if (!field) {
      return;
    }

    const parentWrapper = field.closest(`.${wrapperClass}`);
    if (!parentWrapper) {
      return;
    }

    let errorSpan = parentWrapper.querySelector('.wpcf7-not-valid-tip');

    if (!field.value) {
      if (!errorSpan) {
        errorSpan = document.createElement('span');
        errorSpan.setAttribute('role', 'alert');
        errorSpan.classList.add('wpcf7-not-valid-tip');
        errorSpan.textContent = 'Vänligen fyll i detta fält.';
        parentWrapper.appendChild(errorSpan);
      }
    } else {
      // Check length for registration number fields
      if ((fieldId === 'reg' || fieldId === 'reg-hus') && field.value.length !== 6) {
        if (!errorSpan) {
          errorSpan = document.createElement('span');
          errorSpan.setAttribute('role', 'alert');
          errorSpan.classList.add('wpcf7-not-valid-tip');
          errorSpan.textContent = 'Vänligen skriv ett giltigt registreringsnummer.';
          parentWrapper.appendChild(errorSpan);
        }
      } else {
        if (errorSpan) {
          errorSpan.remove();
        }
      }
    }
  },
  clearValidationMessages() {
    const errorSpans = document.querySelectorAll('.wpcf7-not-valid-tip');
    errorSpans.forEach((span) => span.remove());
    
    // Also clear any custom input length error classes
    const inputLengthErrors = document.querySelectorAll('.input-length-error');
    inputLengthErrors.forEach((error) => error.remove());
  },  
  sendClientEmail(valuation){
    const page = document.querySelector('.page-id-6') || 
                 document.querySelector('.page-id-113') || 
                 document.querySelector('.page-id-111') || 
                 document.querySelector('.page-id-1092') || 
                 document.querySelector('.page-id-948') || 
                 document.querySelector('.page-id-946') || 
                 document.querySelector('.page-id-1204') || 
                 document.querySelector('.page-id-1206') || 
                 document.querySelector('.page-id-839'); // leads page.

    if(!page){
      console.log('wrong page');
      return;
    }

    const email = localStorage.getItem('vincents-user-email');
    const singleprice = localStorage.getItem('specific-price') || '';
    const hash =  this.getHashFromUrl();

    // console.log('sendClientEmail');
    // console.log('email ' + email);
    // console.log('hash ' + hash);

    if(!email || !hash) {
      return;
    }

    const formData = new FormData();

    // formData.append('action', 'send_valuation_form_pdf');
    // if (page.classList.contains('page-id-839')) { //local tests
    if (page.classList.contains('page-id-1092')) {
      formData.append('action', 'send_valuation_form_pdf_leads');
    } else {
      formData.append('action', 'send_valuation_form_pdf');
    }

    formData.append('email', email );
    formData.append('valuation', valuation);
    formData.append('singleprice', singleprice);
    formData.append('hash', hash);

    fetch(SiteVars.ajaxUrl, {
      method: 'POST',
      body: formData,
    })
      .then((response) => response.json())
      .then((res) => {

        // console.log(res);
        // console.log('success send');
        // console.log('singleprice: ' + singleprice);
        localStorage.removeItem('vincents-user-email');
        localStorage.removeItem('vincents-vehicle-clientName');
        localStorage.removeItem('regnr-vehicle');
        localStorage.removeItem('vincents-vehicle-brand');
        localStorage.removeItem('arsmodell-vehicle');
        localStorage.removeItem('vincents-vehicle-milage');
        localStorage.removeItem('vincents-vehicle-clienttelefon');
        localStorage.removeItem('valuation-price');
        localStorage.removeItem('specific-price');
        localStorage.removeItem('can_be_contacted');
        localStorage.removeItem('marketingPreference');
        // console.log('localStorage cleared');
      });
  },
  saveValuation(valuation){
    const url = new URL(window.location.href);

    const pathname = url.pathname;
    const step = pathname.split('/').filter(part => part !== '')[0];
    const singleprice = localStorage.getItem('specific-price') || '';

    // console.log('step ' + step);

    // const endpoints = ['vardering-resultat'];
    const endpoints = ['vardering-resultat-klar', 'vardering-resultat-kontakt-klar'];
    if(!endpoints.includes(step)){
      return;
    }

    const hash =  this.getHashFromUrl();

    if(!hash || !valuation) {
      return;
    }

    const formData = new FormData();
    formData.append('action', 'save_valuation');
    formData.append('valuation', valuation );
    formData.append('singleprice', singleprice);
    formData.append('hash', hash);

    // fetch(SiteVars.ajaxUrl, {
    //   method: 'POST',
    //   body: formData,
    // })
    //   .then((response) => response.json())
    //   .then((res) => {

    //     // console.log(res);
    //   });
  },
  addACTag(){

    const url = new URL(window.location.href);

    const pathname = url.pathname;
    const step = pathname.split('/').filter(part => part !== '')[0];

    const endpoints = ['vardering-resultat', 'vardering-resultat-klar', 'vardering-inga-resultat', 'vardering-inga-resultat-klar', 'vardering-tack', 'vardering-resultat-kontakt-klar'];
    if(!endpoints.includes(step)){
      return;
    }

    const email = localStorage.getItem('vincents-user-email');
    // console.log('email ' + email);

    if(!email) {
      return;
    }



    const formData = new FormData();
    formData.append('action', 'ac_tag');
    formData.append('email', email );
    formData.append('step', step);


    fetch(SiteVars.ajaxUrl, {
      method: 'POST',
      body: formData,
    })
      .then((response) => response.json())
      .then((res) => {

        // console.log(res);
      });
  },
  addACVaulation(valuation){

    const url = new URL(window.location.href);


    const pathname = url.pathname;
    const step = pathname.split('/').filter(part => part !== '')[0];

    // const endpoints = ['vardering-resultat'];
    const endpoints = ['vardering-resultat-klar', 'vardering-resultat-kontakt-klar'];
    if (!endpoints.includes(step)) {
      return;
    }

    const email = localStorage.getItem('vincents-user-email');
    // console.log('email ' + email);

    if(!email) {
      return;
    }



    const formData = new FormData();
    formData.append('action', 'ac_valuation');
    formData.append('email', email );
    formData.append('valuation', valuation);


    fetch(SiteVars.ajaxUrl, {
      method: 'POST',
      body: formData,
    })
      .then((response) => response.json())
      .then((res) => {

        // console.log(res);
      });
  },
  getAuthHeaders() {
    const username = valuationForm.apiLogin;
    const password = valuationForm.apiPassword;
    const credentials = btoa(`${username}:${password}`);
    return {
        'Authorization': `Basic ${credentials}`,
        'Content-Type': 'application/json'
    };
  },
  async fetchAllModelsForMarke(markId) {
    const apiUrl = `https://yxq8qqjulg.wpdns.site/wp-json/wp/v2/modell`;
    const perPage = 100;
    let allModels = [];
    const typeModel = { 'husbil': 25, 'husvagn': 3 }[localStorage.getItem('vincents-vehicle-type')];

    try {
      let page = 1;
      let totalPages = 1; // Start with at least one request

      while (page <= totalPages) {
        const response = await fetch(`https://yxq8qqjulg.wpdns.site/wp-json/wp/v2/model?mark=${markId}&per_page=${perPage}&page=${page}`, {
          method: 'GET',
          headers: this.getAuthHeaders()
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        // const models = await response.json();
        // const filteredModels = models.filter(model => model['model-type'].includes(typeModel));
        // allModels = allModels.concat(filteredModels);
        // totalPages = response.headers.get('X-WP-TotalPages'); // Get total pages from response headers

        const models = await response.json();
        const filteredModels = models.filter(model => model['model-type'].includes(typeModel));
        const combined = [...allModels, ...filteredModels];
        allModels = [...new Map(combined.map(item => [item.id, item])).values()];
        totalPages = parseInt(response.headers.get('X-WP-TotalPages'), 10);

        page++;
      }
      // console.log(allModels);
      return allModels;
    } catch (error) {
      console.error('Error fetching models:', error);
      return []; // Return empty array or handle error as needed
    }
  },
    async fetchMarke(selectId) {
      const taxonomySlug = 'marke'; // Replace with your actual taxonomy slug
      const apiUrl = `https://yxq8qqjulg.wpdns.site/wp-json/wp/v2/mark?per_page=100`;
      let markeSelect = document.getElementById(`marke-${selectId}`);


      // console.log('markeSelect: ' + markeSelect);

      if(!markeSelect){
        markeSelect = document.getElementById(`marke`);
        markeSelect.parentElement.classList.add('loading--select');
      }
      // console.log(selectId);
      if(markeSelect){
        markeSelect.parentElement.classList.add('loading--select');
        markeSelect.disabled;
      }

      try {
        const response = await fetch(apiUrl, {
          method: 'GET',
          headers: this.getAuthHeaders()
        });

        if (!response.ok) {
          if(markeSelect){
            markeSelect.parentElement.classList.remove('loading--select');
            markeSelect.enabled;
          }
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();

        const carTypeSelect = document.getElementById('car-type');
        let vehicleType = 'husbil'; // Default value
        if (carTypeSelect) {
          vehicleType = carTypeSelect.value;
        }
        // console.log('Selected vehicle type:', vehicleType);

        // Filter terms based on acf.mark_type value
        const filteredTerms = data.filter(term => {
          const markType = term.acf.mark_type; // Adjust according to your ACF field structure
          const vehicleType = localStorage.getItem('vincents-vehicle-type');
          // console.log(vehicleType );
          const allowedTypes = ['all', vehicleType]; // 'vehicleType husbil or husvagn

          return allowedTypes.includes(markType);
        });

        // Extract name and ID from filtered terms
        const terms = filteredTerms.map(term => ({
          name: term.name,
          id: term.id,
          interest: term.acf.interest,
        }));
        // console.log(terms);

        markeSelect.parentElement.classList.remove('loading--select');

        this.updateMarkeSelect(vehicleType, terms);

        // console.log(terms);
        if(markeSelect){
          markeSelect.parentElement.classList.remove('loading--select');
          markeSelect.enabled;
        }
        // return terms;

      } catch (error) {
        console.error('Error fetching taxonomy terms:', error);
        return []; // Return empty array or handle error as needed
      }
    },
    updateMarkeSelect(id, data){
      const initialVehicleType = localStorage.getItem('vincents-vehicle-type');
      // console.log('Type: ' + initialVehicleType);
      const markContainer = document.getElementById(initialVehicleType === 'husbil' ? 'husbil-marke-wrapper' : 'husvagn-marke-wrapper');
      let markeSelect = document.getElementById('marke-'+id);

      let dynamicModel;
      let step = 0;
      if(!markeSelect){
        markeSelect = document.getElementById('marke');
        // console.log('markeSelect step2: ' + markeSelect.value);
        step = 2;
      }

      if (step == 2) {
        dynamicModel = document.getElementById('modell');
        const wrapSpan = document.createElement('span');
        wrapSpan.className = 'wpcf7-form-control-wrap';
        wrapSpan.setAttribute('data-name', 'marke');
        wrapSpan.appendChild(markeSelect);

        markContainer.innerHTML = `<label for="marke-${initialVehicleType}">Märke</label>`;
        markContainer.appendChild(wrapSpan);
        // console.log('step 2');
        

      } else {
        dynamicModel = document.getElementById('model-'+id);
        markContainer.innerHTML = `<label for="marke-${initialVehicleType}">Märke</label>`;
        markContainer.appendChild(markeSelect);
      }


      if( markeSelect ) {
        
        const markeStored = localStorage.getItem('vincents-vehicle-brand') || 'Välj...';
        markeSelect.innerHTML = `<option value="" disabled selected hidden>${markeStored}</option>`;

        if (Array.isArray(data)) {
          data.forEach(function(model) {
            const option = document.createElement('option');
            option.value = model.id;
            option.textContent = model.name;
            if (model.interest) {
              option.dataset.notInterested = true;
            }
            markeSelect.appendChild(option);
          });
          if(step == 2){
            const modelFromStorage =
            localStorage.getItem('vincents-husvagn-brand-id') || localStorage.getItem('vincents-vehicle-brand-id');
            const modelFromStorageLabel =
            localStorage.getItem('vincents-husvagn-brand') || localStorage.getItem('vincents-vehicle-brand');
            // console.log(modelFromStorage);
            if(modelFromStorage && modelFromStorageLabel){
              valuation.fillFormField('#marke', modelFromStorage);
              valuation.fillFormField('#markeValue', modelFromStorageLabel);
            }

            const savedModel = localStorage.getItem('vincents-'+id+'-model') || '';
            // console.log('Type:', id);
            // console.log('step2 Model saved:', savedModel);

          }
          this.triggerModelFetch(id);
          this.initNiceSelect(`marke-${id}`);
          // NiceSelect.bind(markeSelect);

          let modelInput = document.getElementById(`model-${id}-list`);
          // console.log('modelInput: ' + modelInput);
          if(modelInput) {
            modelInput.classList.add('hidden');
          }

          //Dynamic Save
          // console.log(dynamicModel);
          dynamicModel.addEventListener('input', function() {
            localStorage.setItem('vincents-'+id+'-model', this.value);
            const savedModel = localStorage.getItem('vincents-'+id+'-model') || '';
            // console.log('Model saved:', savedModel);
          });
        }
      }
    },
    updateModelSelect(id, data) {
      const initialVehicleType =
        localStorage.getItem('vincents-vehicle-type') || 'husvagn';
      const modelContainer = document.getElementById(
        initialVehicleType === 'husbil' ? 'husbil-model-wrapper' : 'husvagn-model-wrapper'
      );
    
      const savedModel = localStorage.getItem('vincents-' + initialVehicleType + '-model');
    
      let markeSelect = document.getElementById(`model-${id}`);
      if (!markeSelect) {
        markeSelect = document.getElementById(
          initialVehicleType === 'husbil' ? 'modell' : 'modell-hus'
        );
      }
    
      let label = modelContainer.querySelector('label');
      if (!label) {
        label = document.createElement('label');
        label.setAttribute('for', `model-${initialVehicleType}`);
        label.textContent = 'Modell';
        modelContainer.prepend(label);
      }

      localStorage.removeItem('model-status');
      if (savedModel === 'Övrigt') {
        localStorage.setItem('model-status', 'false');
      } else {
        localStorage.setItem('model-status', 'true');
      }
    
      if (savedModel !== 'Övrigt') {
    
        let modelInput = document.getElementById(`model-${initialVehicleType}-list`);
        if (!modelInput) {
          modelInput = document.createElement('div');
          modelInput.id = `model-${id}-list`;
          modelInput.className = 'autocomplete-items';
          modelContainer.appendChild(modelInput);
        } else {
          modelInput.innerHTML = '';
        }
    
        const createOtherOption = () => {
          // const otherOption = document.createElement('div');
          // otherOption.className = 'autocomplete-item other-option';
          // otherOption.textContent = 'Övrigt';
          // otherOption.setAttribute('data-value', 'other');
          
  
          // otherOption.onclick = function () {
          //   markeSelect.value = '';
          //   markeSelect.setAttribute('data-value', 'other');
          //   markeSelect.setAttribute('placeholder', 'Skriv in din modell');
          //   markeSelect.focus();

          //   const previousSelected = document.querySelector('.autocomplete-item.selected');
          //   if (previousSelected) {
          //     previousSelected.classList.remove('selected', 'focus');
          //   }
          //   this.classList.add('selected');
          //   modelInput.classList.add('hidden');
          // };
    
          // modelInput.appendChild(otherOption);
          modelContainer.classList.remove('loading--select');
        };
    
        if (Array.isArray(data) && data.length > 0) {
          data.sort((a, b) => a.title.rendered.localeCompare(b.title.rendered));
    
          data.forEach(function(model) {
            const item = document.createElement('div');
            
            const textarea = document.createElement("textarea");
            textarea.innerHTML = model.title.rendered;
            const decodedTitle = textarea.value;

            item.textContent = decodedTitle;
            item.setAttribute('data-value', model.id);
    
            if (model.acf && model.acf.interest) {
              item.dataset.notInterested = true;
            }
            item.className = 'autocomplete-item';
            item.onclick = function() {
              markeSelect.value = decodedTitle;
              markeSelect.setAttribute('data-value', model.id);
              
              localStorage.setItem('vincents-' + id + '-model', markeSelect.value);

              if (this.hasAttribute('data-not-interested') || this.dataset.notInterested) {
                localStorage.setItem('model-interest', 'not-interested');
              } else {
                localStorage.removeItem('model-interest');
              }
    
              const previousSelected = document.querySelector('.autocomplete-item.selected');
              if (previousSelected) {
                previousSelected.classList.remove('selected', 'focus');
              }
              this.classList.add('selected');
              modelInput.classList.add('hidden');
    
              valuation.fillFormField('#modellValue', markeSelect.value);
            };
    
            modelInput.appendChild(item);
            modelContainer.classList.remove('loading--select');
          });
    
          createOtherOption();
        } else {
          createOtherOption();
        }
    
        markeSelect.addEventListener('focus', function() {
          const items = modelInput.querySelectorAll('.autocomplete-item');
          items.forEach(item => {
            item.style.display = '';
          });
          modelInput.classList.remove('hidden');
        });
    
        markeSelect.addEventListener('click', function() {
          const items = modelInput.querySelectorAll('.autocomplete-item');
          items.forEach(item => {
            item.style.display = '';
          });
          modelInput.classList.remove('hidden');
        });
    
        markeSelect.addEventListener('input', function() {
          if (markeSelect.dataset.value === 'other') {
            modelInput.classList.add('hidden');
            localStorage.setItem('vincents-' + id + '-model', markeSelect.value);
            return;
          }
          const filterText = this.value.toLowerCase();
          const items = modelInput.querySelectorAll('.autocomplete-item');
    
          function normalizeText(text) {
            return text
              .replace(/\s+/g, '')
              .replace(/[üÜ]/g, 'u')
              .replace(/[öÖ]/g, 'o')
              .replace(/[äÄ]/g, 'a')
              .replace(/[åÅ]/g, 'a')
              .toLowerCase()
              .trim()
              .replace(/\s+/g, ' ');
          }
    
          let visibleItems = 0;
    
          items.forEach(item => {
            if (!item.classList.contains('other-option')) {
              const text = normalizeText(item.textContent);
              const normalizedFilterText = normalizeText(filterText);
              if (text.includes(normalizedFilterText)) {
                item.style.display = '';
                visibleItems++;
              } else {
                item.style.display = 'none';
              }
            } else {
              item.style.display = '';
            }
          });
    
          if (visibleItems === 0) {
            modelInput.classList.add('hidden');
          } else {
            modelInput.classList.remove('hidden');
          }
        });
    
        document.addEventListener('click', function(event) {
          if (!modelContainer.contains(event.target) && event.target !== markeSelect) {
            modelInput.classList.add('hidden');
          }
        });
    
        markeSelect.addEventListener('blur', function() {
          if (markeSelect.dataset.value !== 'other') {
            const items = modelInput.querySelectorAll('.autocomplete-item');
            let foundMatch = false;
    
            items.forEach(item => {
              if (item.textContent.toLowerCase() === markeSelect.value.toLowerCase()) {
                foundMatch = true;
              }
            });
    
            if (!foundMatch) {
              markeSelect.value = '';
              markeSelect.setAttribute('data-value', '');
            }
          } else {
            localStorage.setItem('vincents-' + id + '-model', markeSelect.value);
          }
        });
    
        markeSelect.addEventListener('input', function() {
          if (markeSelect.dataset.value === 'other') {
            localStorage.setItem('vincents-' + id + '-model', markeSelect.value);
          }
        });
    
      } else {
        modelContainer.classList.remove('loading--select');
        markeSelect.value = ''; 
        markeSelect.setAttribute('data-value', 'other'); 
      }
    },
    fillFormField (selector, value = '') {
      // console.log('fillFormField')
      // console.log(selector)
      const field = document.querySelector(`${selector}`);
      // console.log(field)
      // console.log(value)
      if (field) {
        field.value = value;
        field.dispatchEvent(new Event('change'));
      }

    },
    initMarkeFetch() {
      // console.log('init marke');
      const radioButtons = document.getElementById('car-type');
      const marke = document.getElementById('marke');
      if(marke){
        // console.log('marke');
        //This is for second step
        let initialVehicleType = localStorage.getItem('vincents-vehicle-type');
        this.fetchMarke(`${initialVehicleType}`);
        // return;

        // console.log(initialVehicleType );
      }

      

      let selectedValue;
      // let selectedValue = null;
      if(radioButtons){
        // console.log('radiobuttons');
        selectedValue = radioButtons.value;
        radioButtons.addEventListener('change', () => {
          // console.log('update marke');
          selectedValue = radioButtons.value;
          this.fetchMarke(`${selectedValue}`);
          // console.log('selectedValue ' + selectedValue);
          //clear saved marke
          localStorage.removeItem('vincents-vehicle-brand');

          // localStorage.removeItem('vincents-husbil-brand');
          // localStorage.removeItem('vincents-husvahn-brand');
        });
      }
      // let selectedValue = radioButtons.value;

      // radioButtons.forEach(radio => {
      //   radio.addEventListener('change', () => {
      //     if (radio.checked) {
      //       selectedValue = radio.id;
      //       this.fetchMarke(`${selectedValue}`);
      //     }
      //   });
      // });



      // Initial fetch with default selected radio button
      // const checkedRadio = document.querySelector('input[name="car-type"]:checked');
      // if (checkedRadio) {
      //   selectedValue = checkedRadio.id;
      //   this.fetchMarke(`${selectedValue}`);
      // }
      if (selectedValue) {
        this.fetchMarke(`${selectedValue}`);
      }
    },
    triggerModelFetch(id){

      let selectMarke = document.getElementById(`marke-${id}`);
      const initialVehicleType = localStorage.getItem('vincents-vehicle-type') || 'husvagn';
      const modelContainer = document.getElementById(initialVehicleType === 'husbil' ? 'husbil-model-wrapper' : 'husvagn-model-wrapper');

      // const selectedModel = localStorage.getItem('vincents-husbil-model');

      if(!selectMarke){
        selectMarke = document.getElementById(`marke`);
      }
      if(!selectMarke){
        return;
      }
      selectMarke.addEventListener('change', async () => {

        const selectedValue = selectMarke.value;
        const selectedValueLabel = selectMarke.options[selectMarke.selectedIndex].text;
        valuation.fillFormField('#markeValue', selectedValueLabel);
        valuation.fillFormField('#markeValue-hus', selectedValueLabel);

        modelContainer.classList.add('loading--select');

        if (selectedValue) {
          const models =  await this.fetchAllModelsForMarke(selectedValue);
          this.updateModelSelect(id, models);

        } else {
          modelDropdown.innerHTML = '';
        }
      });
    },
    onModelChange(){
      const selectModels = document.querySelectorAll('#modell, #modell-hus');
      selectModels.forEach((selectModel) => {
        selectModel.addEventListener('change', async () => {
          valuation.fillFormField('#modellValue', selectModel.value);
          valuation.fillFormField('#modellValue-hus', selectModel.value);
        });
      });
    },
    dataSubmissionCRM() {

      const vehicleType = localStorage.getItem('vincents-vehicle-type') || '';

      const selectArsmodells = document.querySelectorAll('#arsmodell, #arsmodell-hus');
      let arsmodell = '';
      selectArsmodells.forEach((selectArsmodell) => {
        selectArsmodell.addEventListener('change', () => {
          localStorage.setItem('arsmodell-vehicle', selectArsmodell.value);
          // console.log(selectArsmodell.value);
        });
      });

      const regInputs = document.querySelectorAll('#reg, #reg-hus');
      let regNr = '';
      if(regInputs){
        regInputs.forEach((regInput) => {
          regInput.addEventListener('change', () => {
            localStorage.setItem('regnr-vehicle', regInput.value);
            // console.log(regInput.value);
          });
        });
      }

      const clientNameInputs = document.querySelectorAll('#for-och, #for-och-hus');
      let clientName  = ''; 
      if(clientNameInputs){
        clientNameInputs.forEach((clientNameInput) => {
          clientNameInput.addEventListener('change', () => {
            localStorage.setItem('vincents-vehicle-clientName', clientNameInput.value);
            // console.log(clientNameInput.value);
          });
        });
      }

      const clientTelefonInputs = document.querySelectorAll('#telefon, #telefon-hus');
      let clientTelefon  = ''; 
      if(clientTelefonInputs){
        clientTelefonInputs.forEach((clientTelefonInput) => {
          clientTelefonInput.addEventListener('change', () => {
            localStorage.setItem('vincents-vehicle-clienttelefon', clientTelefonInput.value);
            // console.log(clientTelefonInput.value);
          });
        });
      }

      let vehicleMilage = ''; 
      const milageInput = document.getElementById('mitial');
      if(milageInput){
        localStorage.setItem('vincents-vehicle-milage', milageInput.value);
        milageInput.addEventListener('change', () => {
          localStorage.setItem('vincents-vehicle-milage', milageInput.value);
          // console.log(milageInput.value);
        });
      }

      let currentModel  = ''; 
      if (vehicleType === 'husbil') {
        vehicleMilage = localStorage.getItem('vincents-vehicle-milage') || '';
        currentModel = localStorage.getItem('vincents-husbil-model') || '';
        // console.log(vehicleMilage);
      } else {
        vehicleMilage = localStorage.getItem('vincents-vehicle-milage') || '';
        currentModel = localStorage.getItem('vincents-husvagn-model') || '';
      }

      const modelInputs = document.querySelectorAll('#modellValue, #modellValue-hus');
      if(modelInputs){
        modelInputs.forEach((modelInput) => {
          modelInput.addEventListener('change', () => {
            localStorage.setItem('vincents-husbil-model', modelInput.value);
            localStorage.setItem('vincents-husvagn-model', modelInput.value);
            // console.log(modelInput.value);
          });
        });
      }

      const markeInputs = document.querySelectorAll('#marke, #marke-hus');
      let currentMarke  = ''; 
      if(markeInputs){
        markeInputs.forEach((markeInput) => {
          markeInput.addEventListener('change', () => {
            const selectedOptionText = markeInput.options[markeInput.selectedIndex].textContent;
            localStorage.setItem('vincents-vehicle-brand', selectedOptionText);
            // console.log(selectedOptionText);
          });
        });
      }

      const clientEmailInputs = document.querySelectorAll('#mail, #mail-hus');
      let clientEmail  = ''; 
      if(clientEmailInputs){
        clientEmailInputs.forEach((clientEmailInput) => {
          clientEmailInput.addEventListener('change', () => {
            localStorage.setItem('vincents-user-email', clientEmailInput.value);
            // console.log(clientEmailInput.value);
          });
        });
      }

      let contacted  = ''; 
      const acceptanceCheckboxes = ['acceptance-61', 'acceptance-661'];
      acceptanceCheckboxes.forEach(name => {
        const checkbox = document.querySelector(`input[name="${name}"]`);
        if (checkbox) {
          localStorage.setItem('can_be_contacted', checkbox.checked ? 1 : 0);
          contacted = localStorage.getItem('can_be_contacted') || '';
          checkbox.addEventListener('change', () => {
            localStorage.setItem('can_be_contacted', checkbox.checked ? 1 : 0);
            contacted = localStorage.getItem('can_be_contacted') || '';
            console.log('contactedChange ' + contacted);
          });
        }
      });

      const selectRegions = document.querySelectorAll('#region, #region-hus');
      let region = '';
      selectRegions.forEach((selectRegion) => {
        selectRegion.addEventListener('change', () => {
          localStorage.setItem('tel-region', selectRegion.value);
          region = localStorage.getItem('tel-region') || '';
          // console.log(selectRegion.value);
        });
      });

      const estimadedPrice = localStorage.getItem('estimated-price') || '';
      // console.log('estimatedPrice: ' + estimadedPrice);

      
      // const formTest = document.getElementById('spec-price');
      // if(formTest){
      //   formTest.value = estimadedPrice;
      //   console.log('FORM TEST ' + formTest.value);
      // }

      // const formTest2 = document.getElementById('spec-price-hus');
      // if(formTest2){
      //   formTest2.value = estimadedPrice;
      //   console.log('FORM TEST2 ' + formTest2.value);
      // }
      
      
      // document.getElementById('modell').value = husbilModel;
      // console.log('update2');
      // const body = document.querySelector('body');
      // const submitButtons = document.querySelectorAll('.wpcf7-submit');
      //   if (submitButtons) {
      //     submitButtons.forEach((submitButton) => {
      //     submitButton.addEventListener('click', () => {
      //       body.classList.add('loading');
      //     })
      //   });
      // }

      const url = new URL(window.location.href);
      const pathname = url.pathname;
      const step = pathname.split('/').filter(part => part !== '');
      const endpoints = ['vardering-resultat', 'vardering-resultat-klar', 'vardering-inga-resultat', 'vardering-inga-resultat-klar', 'vardering-resultat-kontakt-klar'];
      // console.log('vehicleMilage: ' + vehicleMilage);
      const body = document.querySelector('body');

      const submitButtons = document.querySelectorAll('.wpcf7-submit');
      // if (endpoints.includes(step[0])) {
      if (submitButtons) {
        submitButtons.forEach((submitButton) => {
        submitButton.addEventListener('click', () => {
          
        //   body.classList.add('loading');
          // Get all saved data
          clientName = localStorage.getItem('vincents-vehicle-clientName') || '';
          clientEmail = localStorage.getItem('vincents-user-email') || '';
          regNr = localStorage.getItem('regnr-vehicle') || '';
          const vehicleType = localStorage.getItem('vincents-vehicle-type') || '';
          const crmVehicleType = localStorage.getItem('crm-vehicle-type') || '';
          currentMarke = localStorage.getItem('vincents-vehicle-brand') || '';
          arsmodell = localStorage.getItem('arsmodell-vehicle') || '';
          vehicleMilage = localStorage.getItem('vincents-vehicle-milage') || '';
          clientTelefon = localStorage.getItem('vincents-vehicle-clienttelefon') || '';
          currentModel = localStorage.getItem('vincents-'+vehicleType+'-model') || '';
          // console.log('vehicleMilage: ' + vehicleMilage);
          
          const valuationPrice = localStorage.getItem('valuation-price') || '';
          // console.log('valuationPrice: ' + valuationPrice);

          const specificPrice = localStorage.getItem('specific-price') || '';
          // console.log('specificPrice: ' + specificPrice);

          contacted = localStorage.getItem('can_be_contacted') || '';
          region = localStorage.getItem('tel-region') || '';
          if (contacted === '0') {
            region = '';
            localStorage.setItem('tel-region', '');
          }
          const marketingVal = localStorage.getItem('marketingPreference') || '0';
          // console.log('marketing: ' + marketingVal);

          const sendTime = new Date().toISOString();

          const formData = new FormData();
          formData.append('action', 'send_data_to_crm');
          formData.append('security', SiteVars.nonce);
          formData.append('firstname', clientName);
          formData.append('email', clientEmail);
          formData.append('mobile', clientTelefon);
          formData.append('reg_nr', regNr);
          formData.append('type', crmVehicleType);
          formData.append('marke', currentMarke);
          formData.append('modell', currentModel);
          formData.append('arsmodell', arsmodell);
          formData.append('miltal', vehicleMilage);
          formData.append('can_be_contacted', contacted); 
          formData.append('region', region);
          formData.append('valuation_price', valuationPrice);
          formData.append('specific_price', specificPrice);
          formData.append('marketing', marketingVal);
          formData.append('send_time', sendTime);

          // for (const pair of formData.entries()) {
          //   console.log(`Sent data: ${pair[0]} = ${pair[1]}`);
          // }
          
          // console.log("Test sended to CRM");


          // CRM SEND DATA
          // fetch(SiteVars.ajaxUrl, {
          //   method: 'POST',
          //   body: formData,
          // })
          // .then((response) => {
          //   if (!response.ok) {
          //     throw new Error('Network response was not ok');
          //   }
          //   return response.json();
          // })
          // .then((data) => {
          //   if (data.success) {
          //     console.log('Test CRM Response:', data.data);

          //     // Clear local storage data
          //     setTimeout(() => {
          //       localStorage.removeItem('vincents-user-email');
          //       localStorage.removeItem('vincents-vehicle-clientName');
          //       localStorage.removeItem('regnr-vehicle');
          //       localStorage.removeItem('vincents-vehicle-brand');
          //       localStorage.removeItem('arsmodell-vehicle');
          //       localStorage.removeItem('vincents-vehicle-milage');
          //       localStorage.removeItem('vincents-vehicle-clienttelefon');
          //       localStorage.removeItem('valuation-price');
          //       localStorage.removeItem('specific-price');
          //       localStorage.removeItem('can_be_contacted');
          //       localStorage.removeItem('marketingPreference');
          //       console.log('Local storage cleared');
          //     }, 5000);
          //     body.classList.remove('loading');
          //   } else {
          //     console.error('Test CRM Error:', data.data);
          //   }
          // })
          // .catch((error) => {
          //   console.error('Fetch error:', error);
          // });

        });
        });
      }
  },
  regionSelect(){
    // const checkboxes = document.querySelectorAll('input[name="acceptance-661"], input[name="acceptance-61"]');
    // const regionWrappers = document.querySelectorAll('.region-wrapper, .phone-wrapper');

    // if (checkboxes.length && regionWrappers.length) {
    //   checkboxes.forEach(checkbox => {
    //     checkbox.addEventListener('change', () => {
    //       regionWrappers.forEach(regionWrapper => {
    //         regionWrapper.style.display = checkbox.checked ? 'flex' : 'none';
    //         const selects = regionWrapper.querySelectorAll('select');
    //         selects.forEach(select => {
    //           if (!checkbox.checked) {
    //             select.value = '';
    //           }
    //         });
    //       });
    //     });
    //   });
    // }
    this.initNiceSelect('region');
    this.initNiceSelect('region-hus');
  },
  equipmentPrice() {
    // localStorage.setItem('vincents-vehicle-type', 'husvagn');
    // localStorage.setItem('vincents-vehicle-type', 'husbil');
    const vehicleType = localStorage.getItem('vincents-vehicle-type') || '';
    // console.log('checkboxes for ' + vehicleType);

    let checkboxesType;
    if (vehicleType === 'husbil') {
      checkboxesType = document.querySelectorAll('.checkbox-item.husbil');
    } else {
      checkboxesType = document.querySelectorAll('.checkbox-item.husvagn');
    }
    checkboxesType.forEach(check => {
      check.classList.add('active');
    });

    const specificPriceElement = document.getElementById('specific-price');
    const checkboxes = document.querySelectorAll('input[name="equipments"]');

    if (checkboxes) {
      const updatePrice = (event) => {
        let currentPrice = parseFloat(specificPriceElement.textContent.replace(/\D/g, '')) || 0;
        const checkboxValue = parseFloat(event.target.value) || 0;

        if (event.target.checked) {
          currentPrice += checkboxValue;
        } else {
          currentPrice -= checkboxValue;
        }
        specificPriceElement.textContent = `${currentPrice.toLocaleString()} kr`;
      };

      checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', updatePrice);
      });
    }
  },
  hiddenFormFields() {
    document.querySelectorAll('.wpcf7-form').forEach((form) => {
      const submitButton = form.querySelector('input[type="submit"]');
      if (submitButton) {
        submitButton.addEventListener('click', () => {
          const updateFields = (selectors, value, label) => {
            selectors.forEach((selector) => {
              const input = form.querySelector(selector);
              if (input) {
                input.value = value;
                // console.log(`Updated hidden ${label} (${selector}) value: ${input.value}`);
              }
            });
          };
  
          const specificPrice = localStorage.getItem('specific-price') || '';
          updateFields(['#spec-price', '#spec-price-hus'], specificPrice, 'specific-price');
  
          const valuationPrice = localStorage.getItem('valuation-price') || '';
          updateFields(['#val-price', '#val-price-hus'], valuationPrice, 'valuation-price');

          const contacted = localStorage.getItem('can_be_contacted');
          const contactedValue = contacted === '1' ? 'Yes' : 'No';
          updateFields(['#contacted', '#contacted-hus'], contactedValue, 'can_be_contacted');

          const marketing = localStorage.getItem('marketingPreference');
          const marketingValue = marketing === '1' ? 'Yes' : 'No';
          updateFields(['#marketing', '#marketing-hus'], marketingValue, 'marketingPreference');

          const milageForm = localStorage.getItem('vincents-vehicle-milage') || '';
          updateFields(['#milage-form'], milageForm, 'vincents-vehicle-milage');

          const regForm = localStorage.getItem('regnr-vehicle') || '';
          updateFields(['#reg-form'], regForm, 'regnr-vehicle');
          
          const markeForm = localStorage.getItem('vincents-vehicle-brand') || '';
          updateFields(['#marke-form'], markeForm, 'vincents-vehicle-brand');
          
          const vehicleType = localStorage.getItem('vincents-vehicle-type') || '';
          
          const modelForm = localStorage.getItem('vincents-'+vehicleType+'-model') || '';
          updateFields(['#modell-form'], modelForm, 'vincents-'+vehicleType+'-model');

          const arsmodellForm = localStorage.getItem('arsmodell-vehicle') || '';
          updateFields(['#arsmodell-form'], arsmodellForm, 'arsmodell-vehicle');


          const crmVehicleType = localStorage.getItem('crm-vehicle-type') || '';
          const vehicleTypeS = crmVehicleType.charAt(0).toUpperCase() + crmVehicleType.slice(1);
          updateFields(['#type-form'], vehicleTypeS, 'crm-vehicle-type');

        });
      }
    });
  },

  dynamicBlockView() {
    function updateBlockVisibility() {
      const backFs = document.querySelector('fieldset.cf7mls_back_fs');
      const blocks = document.querySelectorAll('.dynamic_hide');
      if (backFs) {
        blocks.forEach(el => {
          el.style.setProperty('display', 'none', 'important');
        });
      } else {
        blocks.forEach(el => {
          el.style.setProperty('display', 'block', 'important');
        });
      }
    }

    const targetNode = document.body;
    const observerConfig = {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['class']
    };

    const observerCallback = function(mutationsList) {
      for (let mutation of mutationsList) {
        if (mutation.type === 'attributes') {
          if (mutation.target.matches('fieldset.fieldset-cf7mls')) {
            updateBlockVisibility();
          }
        }
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1 && node.matches('fieldset.fieldset-cf7mls')) {
              updateBlockVisibility();
            }
          });
          mutation.removedNodes.forEach(node => {
            if (node.nodeType === 1 && node.matches('fieldset.fieldset-cf7mls')) {
              updateBlockVisibility();
            }
          });
        }
      }
    };

    const observer = new MutationObserver(observerCallback);
    observer.observe(targetNode, observerConfig);

    updateBlockVisibility();
  },
  handleResultForm() {
    // Handle form submission on result pages
    const resultForms = document.querySelectorAll('.crm-form .wpcf7-form');
    
    if (resultForms.length > 0) {
      resultForms.forEach((form) => {
        form.addEventListener('wpcf7mailsent', (event) => {
          // console.log('Result form submitted successfully');
          
          // Get form data
          const formData = event.detail.inputs;
          let clientName = '';
          let clientEmail = '';
          let clientTelefon = '';
          
          // Extract form data
          formData.forEach(input => {
            if (input.name === 'for-och' || input.name === 'for-och-hus') {
              clientName = input.value;
            }
            if (input.name === 'mail' || input.name === 'mail-hus') {
              clientEmail = input.value;
            }
            if (input.name === 'telefon' || input.name === 'telefon-hus') {
              clientTelefon = input.value;
            }
          });
          
          // Save to localStorage for CRM
          if (clientName) localStorage.setItem('vincents-vehicle-clientName', clientName);
          if (clientEmail) localStorage.setItem('vincents-user-email', clientEmail);
          if (clientTelefon) localStorage.setItem('vincents-vehicle-clienttelefon', clientTelefon);
          
          // Send data to CRM
          this.sendDataToCRM();
          
          // Send client email
          const valuation = localStorage.getItem('valuation-price') || '';
          if (valuation) {
            this.sendClientEmail(valuation);
          }
          
          // Add AC tags
          this.addACTag();
          this.addACVaulation(valuation);
          
          // Hide form and show confidence block
          const crmForm = document.querySelector('.crm-form');
          const confidenceBlock = document.querySelector('.confidence__block');
          const contactBlock = document.querySelector('.contact__block');
          const noDataBlock = document.querySelector('.no-data__block');
          
          if (crmForm) {
            crmForm.style.display = 'none';
          }
          
          // Remove no-data class from price blocks after successful form submission
          const specificPriceBlock = document.querySelector('.price__block--specific');
          const valuationPriceBlock = document.querySelector('.price__block--valuation');
          const noPriceBlock = document.querySelector('.fc-section__no-price__grid');
          
          if (specificPriceBlock) {
            specificPriceBlock.classList.remove('no-data');
          }
          
          if (valuationPriceBlock) {
            valuationPriceBlock.classList.remove('no-data');
          }
          
          if (confidenceBlock) {
            confidenceBlock.style.display = 'grid';
          }

          // Show contact block only if user agreed to be contacted
          const canBeContacted = localStorage.getItem('can_be_contacted') || '0';
          // console.log('canBeContacted: ' + canBeContacted);
          if (contactBlock && canBeContacted === '1') {
            contactBlock.style.display = 'block';

            if (noPriceBlock) {
              noPriceBlock.style.display = 'none';
            }
          }

          if (canBeContacted === '0') {
            if (noDataBlock) {
              noDataBlock.style.display = 'flex';
            }
          }
          
          // Clear loading class
          document.body.classList.remove('loading');
          
          // console.log('Result form processing completed');
        });
        
        // Add loading class on submit
        form.addEventListener('submit', (event) => {
          // Validate form before submission
          const currentFieldset = form.querySelector('.fieldset-cf7mls:not(.cf7mls_back_fs)');
          if (currentFieldset && !this.validateForm(currentFieldset)) {
            event.preventDefault();
            event.stopPropagation();
            console.log('CRM form validation failed');
            return false;
          }
          
          // Additional validation for registration number length
          const regInput = currentFieldset.querySelector('#reg, #reg-hus');
          if (regInput && regInput.value.length !== 6) {
            event.preventDefault();
            event.stopPropagation();
            this.showInputLengthError(regInput, 'Vänligen skriv ett giltigt registreringsnummer.');
            console.log('Registration number length validation failed');
            return false;
          }
          
          document.body.classList.add('loading');
        });
        // Remove loading class on validation error
        form.addEventListener('wpcf7invalid', () => {
          document.body.classList.remove('loading');
        });
      });
    }
  },
  sendDataToCRM() {
    // Get all saved data from localStorage
    const clientName = localStorage.getItem('vincents-vehicle-clientName') || '';
    const clientEmail = localStorage.getItem('vincents-user-email') || '';
    const clientTelefon = localStorage.getItem('vincents-vehicle-clienttelefon') || '';
    const regNr = localStorage.getItem('regnr-vehicle') || '';
    const vehicleType = localStorage.getItem('vincents-vehicle-type') || '';
    const crmVehicleType = localStorage.getItem('crm-vehicle-type') || '';
    const currentMarke = localStorage.getItem('vincents-vehicle-brand') || '';
    const arsmodell = localStorage.getItem('arsmodell-vehicle') || '';
    const vehicleMilage = localStorage.getItem('vincents-vehicle-milage') || '';
    const currentModel = localStorage.getItem('vincents-'+vehicleType+'-model') || '';
    const valuationPrice = localStorage.getItem('valuation-price') || '';
    const specificPrice = localStorage.getItem('specific-price') || '';
    const contacted = localStorage.getItem('can_be_contacted') || '';
    const region = localStorage.getItem('tel-region') || '';
    const marketingVal = localStorage.getItem('marketingPreference') || '0';
    const sendTime = new Date().toISOString();

    const formData = new FormData();
    formData.append('action', 'send_data_to_crm');
    formData.append('security', SiteVars.nonce);
    formData.append('firstname', clientName);
    formData.append('email', clientEmail);
    formData.append('mobile', clientTelefon);
    formData.append('reg_nr', regNr);
    formData.append('type', crmVehicleType);
    formData.append('marke', currentMarke);
    formData.append('modell', currentModel);
    formData.append('arsmodell', arsmodell);
    formData.append('miltal', vehicleMilage);
    formData.append('can_be_contacted', contacted); 
    formData.append('region', region);
    formData.append('valuation_price', valuationPrice);
    formData.append('specific_price', specificPrice);
    formData.append('marketing', marketingVal);
    formData.append('send_time', sendTime);

    // for (const pair of formData.entries()) {
    //     console.log(`Sent data: ${pair[0]} = ${pair[1]}`);
    //   }
      
      // console.log("Test sended to CRM");

    // Send to CRM
    fetch(SiteVars.ajaxUrl, {
      method: 'POST',
      body: formData,
    })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then((data) => {
      if (data.success) {
        // console.log('CRM Response:', data.data);

        
        // Clear local storage data after successful submission
        setTimeout(() => {
          localStorage.removeItem('vincents-vehicle-clientName');
          localStorage.removeItem('vincents-user-email');
          localStorage.removeItem('vincents-vehicle-clienttelefon');
          localStorage.removeItem('regnr-vehicle');
          localStorage.removeItem('vincents-vehicle-brand');
          localStorage.removeItem('arsmodell-vehicle');
          localStorage.removeItem('vincents-vehicle-milage');
          localStorage.removeItem('valuation-price');
          localStorage.removeItem('specific-price');
          localStorage.removeItem('can_be_contacted');
          localStorage.removeItem('marketingPreference');
          localStorage.removeItem('mark-interest');
          localStorage.removeItem('model-interest');
          localStorage.removeItem('admin-email');
        }, 5000);
      } else {
        console.error('CRM Error:', data.data);
      }
    })
    .catch((error) => {
      console.error('Fetch error:', error);
    });
  },
  validateInputLength() {
    const inputIds = ['reg', 'reg-hus'];
    // console.log('inputIds: ' + inputIds);
    
    inputIds.forEach(id => {
      const input = document.getElementById(id);
      if (!input) return;

      const wrapper = input.closest('.line-wrapper');
      if (!wrapper) return;

      const showError = (message) => {
        // Remove any existing error messages first
        const existingErrors = wrapper.querySelectorAll('.wpcf7-not-valid-tip');
        existingErrors.forEach(error => error.remove());

        // Create and show new error message
        const errorMessage = document.createElement('span');
        errorMessage.className = 'wpcf7-not-valid-tip input-length-error';
        errorMessage.textContent = message;
        wrapper.appendChild(errorMessage);
      };

      const removeError = () => {
        const existingErrors = wrapper.querySelectorAll('.wpcf7-not-valid-tip');
        existingErrors.forEach(error => error.remove());
      };

      input.addEventListener('input', function() {
        if (this.value.length === 0) {
          showError('Vänligen fyll i detta fält.');
        } else if (this.value.length < 6) {
          showError('Vänligen skriv ett giltigt registreringsnummer.');
        } else if (this.value.length > 6) {
          this.value = this.value.slice(0, 6);
          showError('Vänligen skriv ett giltigt registreringsnummer.');
        } else {
          removeError();
        }
      });

      // Handle blur event
      input.addEventListener('blur', function() {
        if (this.value.length === 0) {
          showError('Vänligen fyll i detta fält.');
        } else if (this.value.length !== 6) {
          showError('Vänligen skriv ett giltigt registreringsnummer.');
        }
      });

      // Handle focus event
      input.addEventListener('focus', function() {
        if (this.value.length === 6) {
          removeError();
        } else if (this.value.length > 0 && this.value.length !== 6) {
          showError('Vänligen skriv ett giltigt registreringsnummer.');
        }
      });
    });
  },
  showInputLengthError(input, message) {
    const wrapper = input.closest('.line-wrapper');
    if (!wrapper) return;

    // Remove any existing error messages first
    const existingErrors = wrapper.querySelectorAll('.wpcf7-not-valid-tip');
    existingErrors.forEach(error => error.remove());

    // Create and show new error message
    const errorMessage = document.createElement('span');
    errorMessage.className = 'wpcf7-not-valid-tip input-length-error';
    errorMessage.textContent = message;
    wrapper.appendChild(errorMessage);
  },
  showLimitPopup() {
    const popup = document.getElementById('popup-limit-reached');
    if (popup) {
      popup.style.display = 'flex';
      
      // Close popup functionality
      const closeButton = document.getElementById('close-popup');
      const bodyLoading = document.querySelector('body');
      if (closeButton) {
        closeButton.addEventListener('click', function() {
          popup.style.display = 'none';
          bodyLoading.classList.remove('loading');
        });
      }
    }
  }
}

// console.log('scripts loaded');
document.addEventListener('DOMContentLoaded', valuation.init());

document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll('.cf7mls_next.cf7mls_btn');

  buttons.forEach(button => {
    const buttonText = button.childNodes[0]?.nodeValue?.trim();
    if (buttonText) {
      const span = document.createElement('span');
      span.textContent = buttonText;
      button.childNodes[0].nodeValue = '';
      button.insertBefore(span, button.firstChild);
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.crm-form .wpcf7-form').forEach(function(form) {
    form.addEventListener('wpcf7mailsent', function() {
      // Get values from localStorage
      const specificPrice = localStorage.getItem('specific-price') || '';
      const valuationPrice = localStorage.getItem('valuation-price') || '';
      // console.log('specificPrice: ' + specificPrice);
      // console.log('valuationPrice: ' + valuationPrice);
      // Extract numbers for updateValuationFields
      // specific-price: "123 000 kr" or "123 000 kr"
      // valuation-price: "100 000 kr - 150 000 kr"
      let roundedNewMinVal = null, newMaxVal = null, minCalculated = null;
      if (specificPrice) {
        // Extract number
        roundedNewMinVal = parseInt(specificPrice.replace(/\D/g, ''));
      }
      if (valuationPrice) {
        // Extract two numbers from "100 000 kr - 150 000 kr"
        const matches = valuationPrice.match(/(\d[\d ]*) kr\s*-\s*(\d[\d ]*) kr/);
        if (matches) {
          minCalculated = parseInt(matches[1].replace(/\D/g, ''));
          newMaxVal = parseInt(matches[2].replace(/\D/g, ''));
        }
      }
      // If all values exist, update
      // console.log('roundedNewMinVal: ' + roundedNewMinVal);
      // console.log('newMaxVal: ' + newMaxVal);
      // console.log('minCalculated: ' + minCalculated);
      if (roundedNewMinVal && newMaxVal && minCalculated && typeof valuation.updateValuationFields === 'function') {
        valuation.updateValuationFields(roundedNewMinVal, newMaxVal, minCalculated);
      }
    });
  });
});
